<div class="modal-header">
  <h4 class="modal-title">{{ 'header.menu.csv' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <app-cae-result [caeImportErrorCollectors]="[caeImportErrorCollector]"/>
  </div>
</div>

<div class="modal-footer">
  <button id="step_forward" class="btn btn-primary btn-forward"
          type="button"
          (click)="close()">{{'global.label.next' | translate}}
  </button>
</div>
